import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import messages from "../../../../assets/locale/messages";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";
import Breadcrumbs from "../../../../components/BreadCrumbs";
import { UIPageFormFooter, UITextField } from "../../../../components/ui";
import { createCompanyRoleRequest } from "../../../../store/CompanyPortal/Roles/actions";
import PermissionsMatrix from "./PermissionsMatrix";
import {
  createEmptyPermissions,
  toPermissionsPayload,
} from "./permissionModules";

import "./CreateRole.scss";

const ROLES_TAB_PATH = `${ROUTE_PATHS.companyTeamsPermissions}?tab=roles`;

const CreateRole = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.locale.lang);
  const creating = useSelector((state) => state.companyRoles.creating);
  const teamCopy = messages[lang].teamManagement;
  const copy = teamCopy.createRole;

  const [name, setName] = useState("");
  const [nameTouched, setNameTouched] = useState(false);
  const [permissions, setPermissions] = useState(createEmptyPermissions);

  const trimmedName = name.trim();
  const showNameError = nameTouched && !trimmedName;

  const breadcrumbList = [
    { path: ROUTE_PATHS.companyTeamsPermissions, label: teamCopy.title },
    { path: ROLES_TAB_PATH, label: teamCopy.tabs.roles },
    { path: "", label: copy.title },
  ];

  const goBackToList = () => {
    history.push(ROLES_TAB_PATH);
  };

  const handleSubmit = () => {
    setNameTouched(true);
    if (!trimmedName || creating) return;

    dispatch(
      createCompanyRoleRequest({
        data: {
          name: trimmedName,
          permissions: toPermissionsPayload(permissions),
        },
        onSuccess: goBackToList,
      }),
    );
  };

  return (
    <div className="team-management create-role">
      <div className="mt-2">
        <Breadcrumbs list={breadcrumbList} BreadCrumbHasBackIcon={false} />
        <p className="create-role__subtitle">{copy.subtitle}</p>
      </div>

      <div>
        <UITextField
          label={copy.roleNameLabel}
          name="roleName"
          required
          value={name}
          placeholder={copy.roleNamePlaceholder}
          onChange={(event) => setName(event.target.value)}
          onBlur={() => setNameTouched(true)}
          error={showNameError}
          helperText={showNameError ? copy.roleNameRequired : null}
          classNames={{ root: "create-role__name-field mb-24" }}
        />

        <PermissionsMatrix
          value={permissions}
          onChange={setPermissions}
          copy={copy}
        />
      </div>

      <UIPageFormFooter
        cancelLabel={copy.cancel}
        submitLabel={copy.submit}
        onCancel={goBackToList}
        onSubmit={handleSubmit}
        cancelDisabled={creating}
        submitDisabled={!trimmedName || creating}
        submitLoading={creating}
      />
    </div>
  );
};

export default CreateRole;
